import { Col, Row } from "react-bootstrap";
import { InputBox } from "../form-elements/inputbox.component";
import { DropdownMenu } from "../form-elements/dropdownmenu.component";
import { InputBoxPhone } from "../form-elements/inputbox-phone.component";
import { InputBoxSsn } from "../form-elements/inputbox-ssn.component";
import { maritalStatuses, primaryPhoneTypes, suffix } from "./values";
import { BirthdayInputBox } from "../form-elements/birthday.component";

interface ApplicantInformationFormProps {
  values?: any;
  errors?: any;
  touched?: any;
  handleChange?: any;
  handleBlur?: any;
  setFieldValue?: any;
}

export const initialValuesApplicantInformation = {
  firstName: "",
  middleName: "",
  lastName: "",
  suffix: "",
  emailAddress: "",
  maritalStatus: "",
  birthdate: "",
  primaryPhoneType: "",
  primaryPhoneNumber: "",
  ssn: "",
  createdBy: "",
  phoneNumberCallback: "",
};

export const ApplicantInformationForm: React.FC<ApplicantInformationFormProps> = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
}) => {
  return (
    <>
      <Row>
        <Col xs={12}>
          <h3>Buyer Information</h3>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6} lg={3}>
          <InputBox
            label="First Name"
            type="text"
            name="firstName"
            value={values.firstName}
            onChange={handleChange}
            onBlur={handleBlur}
            isValid={touched.firstName && !errors.firstName}
            isInvalid={touched.firstName && errors.firstName}
            errorFeedback={errors.firstName}
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <InputBox
            label="Middle Name"
            name="middleName"
            value={values.middleName}
            onChange={handleChange}
            onBlur={handleBlur}
            isValid={touched.middleName && !errors.middleName}
            isInvalid={touched.middleName && errors.middleName}
            errorFeedback={errors.middleName}
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <InputBox
            label="Last Name"
            name="lastName"
            value={values.lastName}
            onChange={handleChange}
            onBlur={handleBlur}
            isValid={touched.lastName && !errors.lastName}
            isInvalid={touched.lastName && errors.lastName}
            errorFeedback={errors.lastName}
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <DropdownMenu
            label="Suffix"
            name="suffix"
            options={suffix}
            value={values.suffix}
            onChange={handleChange}
            onBlur={handleBlur}
            isValid={touched.suffix && !errors.suffix}
            isInvalid={touched.suffix && errors.suffix}
            errorFeedback={errors.suffix}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={6}>
          <InputBoxPhone
            label="Phone Number"
            name="primaryPhoneNumber"
            value={values.primaryPhoneNumber}
            onChange={handleChange}
            onBlur={handleBlur}
            setFieldValue={setFieldValue}
            isValid={touched.primaryPhoneNumber && !errors.primaryPhoneNumber}
            isInvalid={touched.primaryPhoneNumber && errors.primaryPhoneNumber}
            errorFeedback={errors.primaryPhoneNumber}
          />
        </Col>
        <Col xs={12} md={6}>
          <DropdownMenu
            label="Phone Number Type"
            name="primaryPhoneType"
            options={primaryPhoneTypes}
            value={values.primaryPhoneType}
            onChange={handleChange}
            onBlur={handleBlur}
            isValid={touched.primaryPhoneType && !errors.primaryPhoneType}
            isInvalid={touched.primaryPhoneType && errors.primaryPhoneType}
            errorFeedback={errors.primaryPhoneType}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={6}>
          <InputBox
            label="E-Mail Address"
            name="emailAddress"
            type="email"
            placeholder="john@example.com"
            value={values.emailAddress}
            onChange={handleChange}
            onBlur={handleBlur}
            isValid={touched.emailAddress && !errors.emailAddress}
            isInvalid={touched.emailAddress && errors.emailAddress}
            errorFeedback={errors.emailAddress}
          />
        </Col>
        <Col xs={12} md={6}>
          <DropdownMenu
            label="Marital Status"
            name="maritalStatus"
            options={maritalStatuses}
            value={values.maritalStatus}
            onChange={handleChange}
            onBlur={handleBlur}
            isValid={touched.maritalStatus && !errors.maritalStatus}
            isInvalid={touched.maritalStatus && errors.maritalStatus}
            errorFeedback={errors.maritalStatus}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={6}>
          <InputBoxSsn
            label="SSN"
            name="ssn"
            // type="password"
            value={values.ssn}
            onChange={handleChange}
            onBlur={handleBlur}
            setFieldValue={setFieldValue}
            isValid={touched.ssn && !errors.ssn}
            isInvalid={touched.ssn && errors.ssn}
            errorFeedback={errors.ssn}
          />
        </Col>

        <Col xs={12} md={6}>
          <BirthdayInputBox
            label="Birth Date"
            name="birthdate"
            value={values.birthdate}
            onChange={(event: any) => setFieldValue("birthdate", event.target.value)}
            onBlur={handleBlur}
            isValid={touched.birthdate && !errors.birthdate}
            isInvalid={touched.birthdate && errors.birthdate}
            errorFeedback={errors.birthdate}
          />
        </Col>
      </Row>
    </>
  );
};
